module.exports = __webpack_public_path__ + "static/media/sorting_it_out.4f592a52.jpg";